import { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../shared/components/button/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  ClienteAtualizar,
  ClienteCadastrar,
} from '../../../../routes/RoutesNames';
import { useSelector } from 'react-redux';
import { Helpers } from '../../../Components/Helpers/Helpers';
import ClienteController from '../../../../controllers/ClienteController';
import { Loader } from '../../../../shared/components/Loader';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';
import FormBuilder from '../../../../shared/components/FormBuilder';
import ModalRelatorioCliente from '../Modal/ModalRelatorioCliente';
import ModalContaCorrente from '../Modal/ModalContaCorrente';

interface Row {
  cli_id: number;
  cli_nome: string;
  cli_uf: string;
  cli_endereco: string;
  cli_cidade: string;
  cli_telefone: string;
  cli_celular: string;
  cli_razao: string;
  cli_ativo: string;
  BtnMenu?: JSX.Element;
}

export default function Cliente() {
  const ref = useRef<HTMLButtonElement>(null);
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const tableColumns: Column[] = [
    { id: 'Id', label: 'Id', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Nome', label: 'Nome', minWidth: 0, maxWidth: undefined },
    { id: 'RazaoSocial', label: 'Razão Social', minWidth: 0, maxWidth: undefined },
    { id: 'Estado', label: 'Estado', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Cidade', label: 'Cidade', minWidth: 0, maxWidth: undefined },
    { id: 'Telefone', label: 'Telefone', minWidth: 0, maxWidth: undefined },
    { id: 'Celular', label: 'Celular', minWidth: 0, maxWidth: undefined },
    { id: 'Situacao', label: 'Situação', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right', maxWidth: undefined },
  ];

  const categoriaSituacao = [
    { label: 'Ativo', value: 'A' },
    { label: 'Inativo', value: 'I' },
    { label: 'Todos', value: 'T' },
  ];

  const fields = [
    { name: 'ClienteId', type: 'number', label: 'Código' },
    { name: 'Nome', type: 'text', label: 'Nome' },
    { name: 'CpfCnpj', type: 'text', label: 'CPF/CNPJ' },
    { name: 'Endereco', type: 'text', label: 'Endereço' },
    { name: 'Cidade', type: 'text', label: 'Cidade' },
    { name: 'ClienteAtivo', type: 'select', label: 'Situação', options: categoriaSituacao },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
  ]

  const [tableRows, setTableRows] = useState<Row[]>([]);

  useEffect(() => {
    ref?.current?.click();
  }, []);

  const handleNavigation = async (): Promise<void> => {
    navigate(ClienteCadastrar);
  };

  /**
   * [25/09] O extrato da conta corrente do cliente.
   *
   * Fica AQUI, e nao numa rota propria, porque quem pergunta "quanto este cliente tem de
   * credito?" ja esta procurando o cliente. Rota nova pediria menu novo e um segundo
   * lugar para procurar a mesma pessoa.
   */
  const [contaCorrenteDe, setContaCorrenteDe] = useState<{ id: number; nome: string } | null>(null);

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(ClienteAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      if (item.cli_id) {
        navigate(ClienteAtualizar.replace(':id', item.cli_id.toString()));
      }
    }
  };

  const handleDeleteItem = async (cli_id: number) => {
    const request: any = { UsuId: userId, ClienteId: cli_id };
    setLoading(true);
    const response = await ClienteController.Excluir(request);
    setLoading(false);

    if (response.StatusCode === 204) {
      toast('Cliente excluído com sucesso!', {
        type: 'success',
      });
    } else {
      toast('Erro ao excluir o cliente!', {
        type: 'error',
      });
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    setLoading(true);
    const payload = {
      ...values,
      CpfCnpj: values.CpfCnpj ? values.CpfCnpj.replace(/\D/g, '') : '',
    };
    console.log("VALUES" + payload)
    const Response = await ClienteController.Listar(payload);
    setLoading(false);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          Id: item.cli_id,
          Nome: item.cli_nome,
          Estado: item.cli_uf,
          Cidade: item.cli_cidade,
          Telefone: Helpers.PhoneMaskShowing(item.cli_telefone),
          Celular: Helpers.CellPhoneMaskShowing(item.cli_celular),
          RazaoSocial: item.cli_razao,
          Situacao: item.cli_ativo == 'S' ? 'Ativo' : 'Inativo',
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: 'Editar' },
                {
                  onClick: () =>
                    setContaCorrenteDe({
                      id: item.cli_id,
                      nome: item.cli_nome ?? item.cli_razao ?? '',
                    }),
                  menu: 'Conta corrente',
                },
                { onClick: () => handleDeleteItem(item.cli_id), menu: 'Excluir', confirmar: `Excluir o cliente "${item.cli_nome ?? item.cli_razao ?? ''}"? Esta ação não pode ser desfeita.` },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'error',
      });
    }
  };

  const initialValues = {
    ClienteId: null,
    Nome: '',
    CpfCnpj: '',
    Endereco: '',
    Cidade: '',
    //DataNascimento: null,
    ClienteAtivo: 'A',
  };

  const handleOpenModalRelatorioCliente = () => {
    setModalRelatorioClienteOpen(true);
  };
  const handleCloseEditarParcelaModal = () => {
    //setSelectedParcela(null); // Limpa ao fechar
    setModalRelatorioClienteOpen(false);
  };

  const [modalRelatorioClienteOpen, setModalRelatorioClienteOpen] = useState(false);

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return (
    <Loader loading={loading}>
      <Box>
        <HeaderComponent text={'Listagem de Clientes'}
          ButtonRight={
            <>
              <Button
                className={''}
                variant='success'
                onClick={handleNavigation}
                iconStart={<Icon.Add />}
                title={'Incluir'}
              />
              <LoadingButton
                //loading={loadingRelatorio}
                loadingPosition="start"
                startIcon={<Icon.FileDownload />}
                variant="outlined"
                onClick={() => handleOpenModalRelatorioCliente()}
                sx={{
                  color: '#fff',
                  backgroundColor: '#1976d2',
                  '&:hover': { backgroundColor: '#1769bb' },
                  textTransform: 'none',
                  marginLeft: '16px',
                  fontSize: '16px',
                  '&&.Mui-disabled': {
                    color: '#ddd',
                  },
                }}
              >
                <p>Relatório</p>
              </LoadingButton>
            </>
          }
        />
        <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} gap='gap-3' />
        <ModalRelatorioCliente
          open={modalRelatorioClienteOpen}
          onClose={handleCloseEditarParcelaModal}
          values={{ selectedItem: 0 }}
          onSuccess={() => { console.log('Relatório gerado com sucesso!') }}
        />
        <ModalContaCorrente
          aberto={contaCorrenteDe !== null}
          clienteId={contaCorrenteDe?.id ?? null}
          clienteNome={contaCorrenteDe?.nome}
          aoFechar={() => setContaCorrenteDe(null)}
        />
        <ComponentTable columns={tableColumns} rows={tableRows} tableHeight={'57vh'} onRowDoubleClick={(row) => {
          handleEditItem(row, true, row.Id);
        }} />
      </Box>
    </Loader>
  );
}
